import React from 'react';
import {t} from '@lingui/core/macro';

import AdminCreateButton from '../AdminList/AdminCreateButton';
import TariffVariantModal from './TariffVariantModal';

const CreateTariffVariantsButton: React.FC = () => (
    <AdminCreateButton label={t`Добавить пакет`} Modal={TariffVariantModal}/>
);

export default React.memo(CreateTariffVariantsButton);
